import { useQuery } from '@tanstack/react-query'
import { color, FormatUtils, TZABrandGuidelines, useAuthedRequestFn, useLink, isNative } from '@my/util'
import { Text, XStack, YStack, Spinner, SimpleText, ActionButton, TZASummaryCards, ScrollView } from '@my/ui'

import { FinancialReviewHeading } from '../../../components/index'
import { SnapShotChart } from './snapShotChart'
import { FinancialCard } from './financialCard'
import images from '../../../assets/images'
import { DollarSign, Scale } from '@tamagui/lucide-icons-2'
import { FinancialProfileButton } from '../../home/helper'

export const FinancialSnapshot = () => {
  const authedRequestFn = useAuthedRequestFn()
  const { data, isLoading } = useQuery({
    queryKey: ['financial-review'],
    queryFn: () => authedRequestFn('/financial-review'),
  })
  const { barChartUI, cardsUI, pieChartUI } = data?.financialSnapshotUI || {}
  const { Assets, Liabilities, NetWorth } = cardsUI || {}

  const financialProfileLinkProps = useLink('/financial-profile');

  if (isLoading) {
    return (
      <YStack flex={1} alignItems={'center'} p="$4">
        <FinancialReviewHeading
          type="Financial Snapshot"
          img={images.FinancialSnapshot}
          imageStyle={{
            //'$platform-web': { width: 20, height: 28 },
          }}
        />
        <Spinner size="large" color={color.tzaGreen} />
      </YStack>
    )
  }

  const mainContent =  (
    <YStack /* f={1} */ p="$4" bg={color.white} gap={25}>
      {/* Heading Section */}
      <FinancialReviewHeading
        title="Financial Snapshot"
        img={images.FinancialSnapshot}
        imageStyle={{
          //'$platform-web': { width: 20, height: 28 },
        }}
      />
      {data?.financialSnapshotUI ? (
        <YStack gap={20}>
          {/* Balance Sheet Label */}
          <XStack justifyContent="flex-start" width="100%">
            <Text color={color.darkNavy} style={{ fontSize: 14, lineHeight: 19, fontWeight: '800' }}>
              BALANCE SHEET
            </Text>
          </XStack>
          {/* Financial Cards */}
          <TZASummaryCards
            cards={[
              {title: NetWorth?.title, value: FormatUtils.currency.cashFormat(NetWorth?.total.value, {decimalPlaces: 0}), icon: <Scale color={color.tzaGreen}/>},
              {
                title: Assets?.title, 
                value: FormatUtils.currency.cashFormat(Assets?.total.value, {decimalPlaces: 0}), 
                expandable: true,
                expanderDetails: {
                  triggerColor: TZABrandGuidelines.colorsMap.secondaryBrightBlue,
                  content: <YStack style={{zIndex: 1, padding: 20}}><FinancialCard
                    title={Assets?.title}
                    total={Assets?.total}
                    themeColor={color.tzaGreen}
                    details={Assets?.values}
                    justMainContent={true}
                  /></YStack>
                }
              },
              {
                title: Liabilities?.title, 
                value: FormatUtils.currency.cashFormat(Liabilities?.total.value, {decimalPlaces: 0}), 
                expandable: true,
                expanderDetails: {
                  triggerColor: TZABrandGuidelines.colorsMap.secondaryMustard,
                  content: <YStack style={{zIndex: 1, padding: 20}}><FinancialCard
                    title={Liabilities?.title}
                    total={Liabilities?.total}
                    themeColor={color.lightRed}
                    details={Liabilities?.values}
                    justMainContent={true}
                  /></YStack>
                }
              }
            ]}
          />
          <XStack justifyContent="flex-start" width="100%">
            <Text color={color.darkNavy} style={{ fontSize: 14, lineHeight: 19, fontWeight: '800' }}>
              MONTHLY INCOME & SPENDING
            </Text>
          </XStack>
          {/* Snapshot Chart  */}
          <SnapShotChart
            donutChartData={pieChartUI}
            barChartData={barChartUI?.monthlySpending}
            total={barChartUI?.grandTotal}
            monthlyCashFlows={data?.monthlyCashFlows}
            netWorthChartData={data?.financialSnapshotUI?.ClientNetWorthChart}
          />
        </YStack>
      ) : (
        <YStack alignItems={'center'}>
          <FinancialProfileButton />
        </YStack>
      )}
    </YStack>
  )
  return isNative
  ? <ScrollView f={1} nestedScrollEnabled scrollEnabled>{mainContent}</ScrollView>
  : mainContent;
}
